import { UnknownError, UUID } from 'symbols';
import { TemplateExpectBackend } from '../../../pdf-templates/symbols';
import { TalonModel, TalonModelExpectBackend } from '../../symbols';

export class CreateTalonTemplate {
  static type = '[TalonManage] CreateTalonTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}

export class UpdateTalonTemplate {
  static type = '[TalonManage] UpdateTalonTemplate';

  constructor(public template: { html?: string, project?: Object, formatId?: UUID, name: string, css: string }, public id: UUID) {
  }
}

export class DeleteTalonTemplate {
  static type = '[TalonManage] DeleteTalonTemplate';

  constructor(public id: UUID) {
  }
}

export class UpdateTalonTemplateSuccess {
  static type = '[TalonManage] UpdateTalonTemplateSuccess';
}

export class UpdateTalonTemplateFail {
  static type = '[TalonManage] UpdateTalonTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetTalonTemplateList {
  static readonly type = '[TalonManage] GetTalonTemplateList';
}

export class GetTalonById {
  static type = '[TalonManage] GetTalonById';

  constructor(public id: UUID) {
  }
}

export class GetTalonByIdSuccess {
  static type = '[TalonManage] GetTalonByIdSuccess';

  constructor(public talon: TalonModel) {
  }
}

export class GetTalonByIdFail {
  static type = '[TalonManage] GetTalonByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentTalonId {
  static type = '[TalonManage] SetCurrentTalonId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalTalon {
  static type = '[TalonManage] UpdateLocalTalon';

  constructor(public talon: TalonModel) {
  }
}

export class DeleteLocalTalon {
  static type = '[TalonManage] DeleteLocalTalon';

  constructor(public id: UUID) {
  }
}


export class UpdateTalon {
  static type = '[TalonManage] UpdateTalon';

  constructor(public id: UUID, public talon: TalonModelExpectBackend, public force: boolean) {
  }
}

export class UpdateTalonSuccess {
  static type = '[TalonManage] UpdateTalonSuccess';

  constructor(public talon: TalonModel) {
  }
}

export class UpdateTalonFail {
  static type = '[TalonManage] UpdateTalonFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateTalon {
  static type = '[TalonManage] CreateTalon';

  constructor(public talon: TalonModelExpectBackend) {
  }
}

export class CreateTalonSuccess {
  static type = '[TalonManage] CreateTalonSuccess';

  constructor(public talon: TalonModel) {
  }
}

export class CreateTalonFail {
  static type = '[TalonManage] CreateTalonFail';

  constructor(public error: UnknownError) {
  }
}

export class CreatedTalonByWS {
  static type = '[talonList] CreatedTalonByWS';

  constructor(public talon: TalonModel) {
  }
}

export class UpdatedTalonByWS {
  static type = '[talonList] UpdatedTalonByWS';

  constructor(public talon: TalonModel) {
  }
}
